import { E_HISTORY_EVENT_TYPE } from 'src/redux/cases/types/casesTypes';
import { COLORS } from 'src/shared/styles/colors';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { E_TYPE_HISTORY_FILTER } from 'src/redux/cases/constants';
export var getHistoryEventType = function (history) {
    var sms = history.sms, access = history.access, status = history.status, email = history.email, acceptedCase = history.acceptedCase, incompleteCase = history.incompleteCase, caseToBeStudied = history.caseToBeStudied, revertedCase = history.revertedCase, kyc = history.kyc, assignment = history.assignment, withdrawnCase = history.withdrawnCase, refusedCase = history.refusedCase, finalizedCase = history.finalizedCase, identityStatusUpdate = history.identityStatusUpdate, signature = history.signature, applicantUpdate = history.applicantUpdate, caseUpdate = history.caseUpdate;
    if (!!sms) {
        return E_HISTORY_EVENT_TYPE.SMS;
    }
    else if (!!access) {
        return E_HISTORY_EVENT_TYPE.ACCESS;
    }
    else if (!!email) {
        return E_HISTORY_EVENT_TYPE.EMAIL;
    }
    else if (!!acceptedCase) {
        return E_HISTORY_EVENT_TYPE.ACCEPTED_CASE;
    }
    else if (!!incompleteCase) {
        return E_HISTORY_EVENT_TYPE.INCOMPLETE_CASE;
    }
    else if (!!caseToBeStudied) {
        return E_HISTORY_EVENT_TYPE.CASE_TO_BE_STUDIED;
    }
    else if (!!revertedCase) {
        return E_HISTORY_EVENT_TYPE.REVERTED_CASE;
    }
    else if (!!kyc) {
        return E_HISTORY_EVENT_TYPE.KYC;
    }
    else if (!!assignment) {
        return E_HISTORY_EVENT_TYPE.ASSIGNMENT;
    }
    else if (!!withdrawnCase) {
        return E_HISTORY_EVENT_TYPE.WITHDRAWN_CASE;
    }
    else if (!!refusedCase) {
        return E_HISTORY_EVENT_TYPE.REFUSED_CASE;
    }
    else if (!!finalizedCase) {
        return E_HISTORY_EVENT_TYPE.FINALIZED_CASE;
    }
    else if (!!identityStatusUpdate) {
        return E_HISTORY_EVENT_TYPE.IDENTITY_STATUS_UPDATE;
    }
    else if (!!signature) {
        return E_HISTORY_EVENT_TYPE.SIGNATURE;
    }
    else if (!!applicantUpdate) {
        return E_HISTORY_EVENT_TYPE.APPLICANT_UPDATE;
    }
    else if (!!caseUpdate) {
        return E_HISTORY_EVENT_TYPE.CASE_UPDATE;
    }
    else {
        return null;
    }
};
export var shouldDisplayEvent = function (historyEvent, historyFilter) {
    var eventType = historyEvent.eventType;
    switch (eventType) {
        case E_HISTORY_EVENT_TYPE.ACCESS:
        case E_HISTORY_EVENT_TYPE.APPLICANT_UPDATE:
        case E_HISTORY_EVENT_TYPE.CASE_UPDATE:
            return historyFilter.some(function (flt) { return flt.type === E_TYPE_HISTORY_FILTER.OTHER; });
        case E_HISTORY_EVENT_TYPE.EMAIL:
        case E_HISTORY_EVENT_TYPE.SMS:
            return historyFilter.some(function (flt) { return flt.type === E_TYPE_HISTORY_FILTER.MESSAGES; });
        case E_HISTORY_EVENT_TYPE.INCOMPLETE_CASE:
        case E_HISTORY_EVENT_TYPE.CASE_TO_BE_STUDIED:
        case E_HISTORY_EVENT_TYPE.ACCEPTED_CASE:
        case E_HISTORY_EVENT_TYPE.REFUSED_CASE:
        case E_HISTORY_EVENT_TYPE.REVERTED_CASE:
        case E_HISTORY_EVENT_TYPE.ASSIGNMENT:
        case E_HISTORY_EVENT_TYPE.WITHDRAWN_CASE:
        case E_HISTORY_EVENT_TYPE.FINALIZED_CASE:
        case E_HISTORY_EVENT_TYPE.IDENTITY_STATUS_UPDATE:
            return historyFilter.some(function (flt) { return flt.type === E_TYPE_HISTORY_FILTER.ETUDE_DU_DOSSIER; });
        case E_HISTORY_EVENT_TYPE.KYC:
        case E_HISTORY_EVENT_TYPE.SIGNATURE:
            return historyFilter.some(function (flt) { return flt.type === E_TYPE_HISTORY_FILTER.COMPLETION; });
        default: {
            console.error('Error event for filter not handled', eventType);
            return true;
        }
    }
};
export var colorOfHistoryEvent = function (eventType) {
    switch (eventType) {
        case E_HISTORY_EVENT_TYPE.ACCESS:
        case E_HISTORY_EVENT_TYPE.APPLICANT_UPDATE:
        case E_HISTORY_EVENT_TYPE.CASE_UPDATE:
            return COLORS.GRAY['500'];
        case E_HISTORY_EVENT_TYPE.EMAIL:
        case E_HISTORY_EVENT_TYPE.SMS:
            return COLORS.BLUE['500'];
        case E_HISTORY_EVENT_TYPE.INCOMPLETE_CASE:
        case E_HISTORY_EVENT_TYPE.CASE_TO_BE_STUDIED:
        case E_HISTORY_EVENT_TYPE.REFUSED_CASE:
        case E_HISTORY_EVENT_TYPE.ACCEPTED_CASE:
        case E_HISTORY_EVENT_TYPE.REVERTED_CASE:
        case E_HISTORY_EVENT_TYPE.ASSIGNMENT:
        case E_HISTORY_EVENT_TYPE.WITHDRAWN_CASE:
        case E_HISTORY_EVENT_TYPE.FINALIZED_CASE:
        case E_HISTORY_EVENT_TYPE.IDENTITY_STATUS_UPDATE:
            return COLORS.RED['500'];
        case E_HISTORY_EVENT_TYPE.KYC:
        case E_HISTORY_EVENT_TYPE.SIGNATURE:
            return COLORS.GREEN['500'];
    }
};
export var labelOfHistoryEvent = function (i18n, eventType) {
    switch (eventType) {
        case E_HISTORY_EVENT_TYPE.ACCESS:
            return getPropsByKeyPath(i18n, 'modules.timeline.access.title');
        case E_HISTORY_EVENT_TYPE.EMAIL:
            return getPropsByKeyPath(i18n, 'modules.timeline.email.title');
        case E_HISTORY_EVENT_TYPE.SMS:
            return getPropsByKeyPath(i18n, 'modules.timeline.sms.title');
        case E_HISTORY_EVENT_TYPE.INCOMPLETE_CASE:
            return getPropsByKeyPath(i18n, 'modules.timeline.incompleteCase.title');
        case E_HISTORY_EVENT_TYPE.CASE_TO_BE_STUDIED:
            return getPropsByKeyPath(i18n, 'modules.timeline.caseToBeStudied.title');
        case E_HISTORY_EVENT_TYPE.REFUSED_CASE:
            return getPropsByKeyPath(i18n, 'modules.timeline.refusedCase.title');
        case E_HISTORY_EVENT_TYPE.ACCEPTED_CASE:
            return getPropsByKeyPath(i18n, 'modules.timeline.acceptedCase.title');
        case E_HISTORY_EVENT_TYPE.REVERTED_CASE:
            return getPropsByKeyPath(i18n, 'modules.timeline.revertedCase.title');
        case E_HISTORY_EVENT_TYPE.ASSIGNMENT:
            return getPropsByKeyPath(i18n, 'modules.timeline.assignment.title');
        case E_HISTORY_EVENT_TYPE.KYC:
            return getPropsByKeyPath(i18n, 'modules.timeline.kyc.title');
        case E_HISTORY_EVENT_TYPE.WITHDRAWN_CASE:
            return getPropsByKeyPath(i18n, 'modules.timeline.withdrawnCase.title');
        case E_HISTORY_EVENT_TYPE.FINALIZED_CASE:
            return getPropsByKeyPath(i18n, 'modules.timeline.finalizedCase.title');
        case E_HISTORY_EVENT_TYPE.IDENTITY_STATUS_UPDATE:
            return getPropsByKeyPath(i18n, 'modules.timeline.identityStatusUpdate.title');
        case E_HISTORY_EVENT_TYPE.SIGNATURE:
            return getPropsByKeyPath(i18n, 'modules.timeline.signature.title');
        case E_HISTORY_EVENT_TYPE.APPLICANT_UPDATE:
            return getPropsByKeyPath(i18n, 'modules.timeline.applicantUpdate.title');
        case E_HISTORY_EVENT_TYPE.CASE_UPDATE:
            return getPropsByKeyPath(i18n, 'modules.timeline.applicantUpdate.title');
        default: {
            console.error('Error label event not handled', eventType);
            return '';
        }
    }
};
